export function getDocEditDocumentTypeList(type: string): { label: string; value: string }[] {
  switch (type) {
    case '교량':
      return [
        { label: '도로교량', value: '도로교량' },
        { label: '복개구조물', value: '복개구조물' },
        { label: '철도교량', value: '철도교량' },
      ]
    case '터널':
      return [
        { label: '도로터널', value: '도로터널' },
        { label: '지하차도', value: '지하차도' },
        { label: '철도터널', value: '철도터널' },
      ]
    case '댐':
      return [
        { label: '다목적댐', value: '다목적댐' },
        { label: '발전용댐', value: '발전용댐' },
        { label: '홍수전용댐', value: '홍수전용댐' },
        { label: '용수전용댐', value: '용수전용댐' },
      ]
    case '건축물':
      return [
        { label: '공동주택', value: '공동주택' },
        { label: '대형건축물', value: '대형건축물' },
        { label: '문화 및 집회시설', value: '문화 및 집회시설' },
        { label: '종교시설', value: '종교시설' },
        { label: '판매시설', value: '판매시설' },
        { label: '운수시설', value: '운수시설' },
        { label: '의료시설', value: '의료시설' },
        { label: '숙박시설', value: '숙박시설' },
        { label: '노유자시설', value: '노유자시설' },
        { label: '수련시설', value: '수련시설' },
        { label: '운동시설', value: '운동시설' },
        { label: '관광휴게시설', value: '관광휴게시설' },
        { label: '철도역시설', value: '철도역시설' },
        { label: '지하도상가', value: '지하도상가' },
        { label: '교육연구시설', value: '교육연구시설' },
      ]
    case '하천':
      return [
        { label: '하구둑', value: '하구둑' },
        { label: '수문 및 통문', value: '수문 및 통문' },
        { label: '제방', value: '제방' },
        { label: '보', value: '보' },
        { label: '배수펌프장', value: '배수펌프장' },
      ]
    case '상하수도':
      return [
        { label: '광역상수도', value: '광역상수도' },
        { label: '공업용수도', value: '공업용수도' },
        { label: '지방상수도', value: '지방상수도' },
        { label: '공공하수처리시설', value: '공공하수처리시설' },
      ]
    case '옹벽':
      return [
        { label: '도로옹벽', value: '도로옹벽' },
        { label: '철도옹벽', value: '철도옹벽' },
        { label: '항만옹벽', value: '항만옹벽' },
        { label: '댐옹벽', value: '댐옹벽' },
        { label: '건축물옹벽', value: '건축물옹벽' },
        { label: '기타옹벽', value: '기타옹벽' },
      ]
    case '절토사면':
      return [
        { label: '도로사면', value: '도로사면' },
        { label: '철도사면', value: '철도사면' },
        { label: '항만사면', value: '항만사면' },
        { label: '댐사면', value: '댐사면' },
        { label: '건축물사면', value: '건축물사면' },
        { label: '기타사면', value: '기타사면' },
      ]
    case '공동구':
      return [{ label: '공동구', value: '공동구' }]
    case '기타':
      return [{ label: '기타', value: '기타' }]
    default:
      return []
  }
}

export function getDocEditDocumentTypeListValue(type: string): { label: string; value: string }[] {
  switch (type) {
    case '1종':
    case '2종':
      return [
        { label: '양호', value: '양호' },
        { label: '보통', value: '보통' },
        { label: '불량', value: '불량' },
      ]
    case '3종':
      return [
        { label: 'A', value: 'A' },
        { label: 'B', value: 'B' },
        { label: 'C', value: 'C' },
        { label: 'D', value: 'D' },
        { label: 'E', value: 'E' },
      ]
    default:
      return []
  }
}
